import { TThunkAction } from '../../types/redux';
import {
  COMPLAIN_REQUEST,
  IComplainRequest,
  COMPLAIN_CHANGE_VISIBILITY,
  IComplainChangeVisibility,
} from '../../constants/actionTypes/complain';
import { createSendFeedback } from '../../api';
import { proccessSendFeedbacksError } from '../../utils/complain';

export interface ISendFeedbackParameters {
  email: string;
  complaintId: number;
}

export const sendFeedback = (offerId: number) => ({ email, complaintId }: ISendFeedbackParameters): TThunkAction => {
  return (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch<IComplainRequest>({ type: COMPLAIN_REQUEST, offerId });

    const sendFeedbackFn = createSendFeedback(httpApi);

    return sendFeedbackFn(email, complaintId)
      .then(() => {
        dispatch<IComplainChangeVisibility>({
          offerId,
          isVisible: false,
          type: COMPLAIN_CHANGE_VISIBILITY,
        });
      })
      .catch(reason => {
        proccessSendFeedbacksError(reason, logger);
        dispatch<IComplainChangeVisibility>({
          offerId,
          isVisible: false,
          type: COMPLAIN_CHANGE_VISIBILITY,
        });
      });
  };
};
